import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const LOGO_URL = "/logo-blanc.png";

export default function LoadingScreen({ onComplete }) {
  const [phase, setPhase] = useState(0);

  useEffect(() => {
    const t1 = setTimeout(() => setPhase(1), 600);
    const t2 = setTimeout(() => setPhase(2), 1800);
    const t3 = setTimeout(() => onComplete(), 2800);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); };
  }, [onComplete]);

  return (
    <AnimatePresence>
      {phase < 2 && (
        <motion.div
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6, ease: "easeInOut" }}
          className="fixed inset-0 z-[100] bg-[#050505] flex items-center justify-center"
          data-testid="loading-screen"
        >
          {/* Pulsing red ring */}
          <motion.div
            className="absolute w-40 h-40 rounded-full border-2 border-[#E60000]/30"
            animate={{ scale: [1, 2.5, 1], opacity: [0.5, 0, 0.5] }}
            transition={{ duration: 2, repeat: Infinity, ease: "easeOut" }}
          />
          <motion.div
            className="absolute w-40 h-40 rounded-full border border-[#E60000]/15"
            animate={{ scale: [1.3, 3, 1.3], opacity: [0.3, 0, 0.3] }}
            transition={{ duration: 2, repeat: Infinity, ease: "easeOut", delay: 0.3 }}
          />

          {/* Logo */}
          <motion.div
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: phase >= 1 ? 1 : 0, scale: phase >= 1 ? 1 : 0.5 }}
            transition={{ duration: 0.6, ease: [0.25, 0.1, 0.25, 1] }}
            className="relative z-10"
          >
            <div style={{ filter: "drop-shadow(0 0 24px rgba(230, 0, 0, 0.45))" }}>
              <img
                src={LOGO_URL}
                alt="DJMIX.CA"
                className="h-10 sm:h-14 w-auto object-contain"
              />
            </div>
          </motion.div>

          {/* Bottom line */}
          <motion.div
            className="absolute bottom-20 left-1/2 -translate-x-1/2 h-[2px] bg-[#E60000]"
            initial={{ width: 0 }}
            animate={{ width: phase >= 1 ? 120 : 0 }}
            transition={{ duration: 1, ease: "easeOut", delay: 0.3 }}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
